"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLogin = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 3c1.554 0 2.897 1.028 2.994 2.436L21 5.6v12.8c0 1.436-1.285 2.517-2.822 2.596L18 21h-5a1 1 0 0 1-.117-1.993L13 19h5c.55 0 .937-.276.993-.536L19 18.4V5.6c0-.255-.345-.55-.866-.594L18 5h-5a1 1 0 0 1-.117-1.993L13 3h5Zm-7.707 4.293a1 1 0 0 1 1.32-.083l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4a1 1 0 0 1-1.497-1.32l.083-.094L12.585 13H3.923C3.413 13 3 12.552 3 12c0-.513.356-.935.815-.993L3.923 11h8.662l-2.292-2.293a1 1 0 0 1-.083-1.32l.083-.094Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgLogin);
//# sourceMappingURL=SvgLogin.js.map